import { redirect, useParams } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import type { PATHS } from "@/routes/paths";

import type { ParamParseKey } from "react-router";

export const useGetVoucherI18nEditPageParams = () => {
	const { hotelID, voucherID, langCode } = useParams<ParamParseKey<typeof PATHS.HOTEL.MARKETING.VOUCHER.I18N>>();

	if (!hotelID || !voucherID || !langCode) {
		redirect("/");
	}

	return { hotelID: hotelID!, voucherID: voucherID!, langCode: langCode! as LangCode };
};
